import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { blogApi, type BlogPostListParams } from '../api/blog-api';

import { blogKeys } from './blog-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function blogPostListQueryOptions(storeId: string, params: BlogPostListParams) {
  return queryOptions({
    queryKey: blogKeys.postList(storeId, params),
    queryFn: () => blogApi.listPosts(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useBlogPosts(storeId: string, params: BlogPostListParams) {
  return useQuery(blogPostListQueryOptions(storeId, params));
}
